import React from 'react';
import { useTranslation } from 'react-i18next';

import { isDefined } from '../../../../../utils/variables';
import { SceneManager } from '../../../../../viewer/scene-manager';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const ClosePanoramaViewerToolIcon = () => {
  const { t } = useTranslation();
  const { skyview, setScene } = React.useContext(SkyviewContext);

  return (
    <ToolIcon
      active={!skyview.getOcclusionCulling()}
      callback={() => {
        const previousSceneType = SceneManager.instance.previousSceneType;
        if (isDefined(previousSceneType)) {
          void setScene(previousSceneType);
        }
      }}
      icon={['fal', 'xmark']}
      tooltip={{
        title: t('panoramaViewer.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('panoramaViewer.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { ClosePanoramaViewerToolIcon };
